import React from "react";
import styles from "./error_screen_wrapper.module.scss";

export const SadBoi: React.FC = () => (
  <span className={styles.sadBoi}>:(</span>
)